import React from "react";
import { Pagination } from 'react-admin';

const RaPagination = props => <Pagination rowsPerPageOptions={[5, 10, 20, 25, 50, 100]} {...props} />;

export default RaPagination